import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  #isDisplay: boolean = false;

  getDisplay(): boolean {
    return this.#isDisplay;
  }

  switchDisplay(): void {
    this.#isDisplay = !this.#isDisplay;
  }

  closeSidebar(): void {
    this.#isDisplay = false;
  }
}
